import { useAuth } from '../pages/login/OAuth';

const useCertificationService = () => {
    const { api } = useAuth();

    const getCertification = (id) =>
        api().get(`/certifications/${id}`);

    const getCertifications = (params) =>
        api().get('/certifications/', { params });

    const createCertification = (data) =>
        api().post('/certifications/new', data);

    const disableCertification = (id) =>
        api().patch('/certifications/disable', { certification_id: id });

    const getCertificationPdf = (id) =>
        api().get(`/certifications/${id}/generate-pdf`, { responseType: 'blob' });

    return {
        getCertification,
        getCertifications,
        createCertification,
        disableCertification,
        getCertificationPdf,
    };
};

export default useCertificationService;
